export default __webpack_public_path__ + "static/media/caps-leave-screenshot.a71865dd.png";